import React, { useMemo } from 'react';
import { PageHeader } from '../../components/PageHeader';
import { Tabs } from '../../components/Tabs';
import type { TabDef } from '../../components/Tabs';
import { useProjects } from '../../hooks/useProjects';
import { useOrganizations } from '../../hooks/useOrganization';
import { FavoritesTab } from './FavoritesTab';
import { MyProjectsTab } from './MyProjectsTab';
import { OrgTab } from './OrgTab';
import { LoadingPlaceholder } from '../../components/LoadingPlaceholder';

export function ProjectListPage() {
  const { data: projects = [], isLoading, isError } = useProjects();
  const { data: organizations = [] } = useOrganizations();

  const favoriteProjects = useMemo(() => projects.filter(p => p.favorite), [projects]);
  const myProjects = useMemo(() => projects.filter(p => p.type === 'account_project'), [projects]);

  const tabs: TabDef[] = [
    {
      id: 'favorites',
      heading: <><i className="fas fa-star" aria-hidden="true" style={{marginRight: "6px"}} />Favorites</>,
      content: <FavoritesTab projects={favoriteProjects} />,
    },
    {
      id: 'myProjects',
      heading: <><i className="fas fa-user" aria-hidden="true" style={{marginRight: "6px"}} />My Projects</>,
      content: <MyProjectsTab projects={myProjects} />,
    },
    ...organizations.map(org => ({
      id: `org-${org.id}`,
      heading: <><i className="fas fa-building" aria-hidden="true" style={{marginRight: "6px"}} />{org.name}</>,
      content: <OrgTab projects={projects} org={org} />,
    })),
  ];

  if (isLoading) return <LoadingPlaceholder label="Loading projects…" />;
  if (isError) return <div className="alert alert-danger">Failed to load projects.</div>;

  return (
    <div>
      <PageHeader icon="fas fa-gavel" title="Projects" />
      <br />
      <Tabs tabs={tabs} defaultTab="favorites" />
    </div>
  );
}
